import styled from "styled-components";
import withTheme from "../../hoc/withTheme";

const PageItem = styled.p`
  color: ${props =>
    props.active
      ? props.theme.colors.background.text
      : `${props.theme.colors.background.text}3f`};
  margin: 0px 15px;
  cursor: pointer;
`;

export default withTheme(PageItem);
